import styled from 'styled-components/native';

import { verticalScale } from '~/utils/layout';

export const Container = styled.View`
  flex-direction: row;
  align-items: center;
  min-height: ${verticalScale(42)}px;
`;
